/**
 *  解译转义后字符串，转义了换行和空格
 * @param str 转义后的字符串
 **/
const decodeString = (str = '') => {
	return (str || '').replace(/{blank_space}/g, ' ').replace(/{line_feed}/g, '\n');
};

export default decodeString;
